import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Born behind our own bar",
    body: "Brew & Co. is the catering arm of Coffee Pause, our tiny neighborhood coffee shop — the kind where regulars have a mug with their name on it. Our catering grew the same way: one friend asked us to pour at their wedding, and we never really stopped.",
  },
  {
    n: "02",
    title: "Café quality, off the grid",
    body: "Our coffee cart carries the same beans, the same grinder, and the same stubborn standards as the shop. We dial in on site, steam fresh milk, and pull every shot to order — no urns, no shortcuts.",
  },
  {
    n: "03",
    title: "Hospitality is the whole point",
    body: "A coffee bar at an event is really a gathering place. We keep the line warm and unhurried, learn a few names, and make sure the last cup of the night is as good as the first.",
  },
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-mono text-[11px] uppercase tracking-[0.3em] text-matcha mb-16"
        >
          About us — a short manifesto
        </motion.p>

        <div className="flex flex-col gap-20">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.05 * i }}
              className="grid md:grid-cols-12 gap-6 md:gap-12"
              data-testid={`about-chapter-${c.n}`}
            >
              <div className="md:col-span-3">
                <span className="font-mono text-sm text-matcha md:sticky md:top-28 inline-block">({c.n})</span>
              </div>
              <div className="md:col-span-9">
                <h2 className="text-3xl lg:text-4xl mb-5">{c.title}</h2>
                <p className="text-base leading-relaxed text-espresso/70 max-w-2xl">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
